//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import VueMq from "vue-mq";

import { ConfigService } from "@nuskin/ns-util";

import { getImagesFromJson } from "../utils/helpers";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export default {
  name: "NsTopnavGivingBack",
  props: {
    /**
     * Product items (max: 4): [{image, alt, link}]
     */
    items: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localItems: []
    };
  },
  watch: {
    items(newVal) {
      this.setItems(newVal);
    }
  },
  mounted: function() {
    this.setItems();
  },
  methods: {
    setItems(val = this.items) {
      const marketConfig = ConfigService.getMarketConfig();
      this.localItems = getImagesFromJson(marketConfig.siteUrl, val);
    }
  }
};
